import React, { Component } from 'react';
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Button,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import isEmail from 'validator/lib/isEmail';
import { Visible } from 'javascripts/portfolio/components/visible';
import { pick, every, mapValues } from 'lodash';
import Captcha from './captcha';

function FieldGroup({
  controlId,
  validationState,
  label,
  helpText,
  children,
  ...props
}) {
  return (
    <FormGroup {...{ controlId, validationState }}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {helpText && <HelpBlock>{helpText}</HelpBlock>}
      {children}
    </FormGroup>
  );
}

FieldGroup.defaultProps = {
  type: 'text',
};

// We do not have access to $r in portfolio
// TODO: Find a way to pass this from the app
const path = '/contact_message';
const SUCCESS = 'success';
const WARN = 'warning';
function generateField(validationState = null, value = '', helpText) {
  return { value, validationState, helpText };
}

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: generateField(),
      subject: generateField(),
      message: generateField(),
      name: generateField(),
      captcha: generateField(),
      contactStatus: '',
      submitted: false,
    };
  }

  handleFieldChange(e, field) {
    const value = e.target.value + '';
    let fieldData;

    if (!value || !value.length) {
      fieldData = generateField();
    } else {
      fieldData = generateField(SUCCESS, value);

      if (field === 'email' && !isEmail(value)) {
        fieldData = generateField(WARN, value, 'Enter a valid email address');
      }
    }

    this.setState({ [field]: fieldData });
  }

  onSubmitClick(e) {
    e.preventDefault();
    this.setState({ contactStatus: '', submitted: true });

    const token = $('meta[name="csrf-token"]').attr('content');
    const request = {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': token,
      },
      body: JSON.stringify({
        contact_message: mapValues(
          pick(this.state, ['email', 'subject', 'name', 'message', 'captcha']),
          'value',
        ),
      }),
    };

    fetch(path, request)
      .then((response) => response.json())
      .then((json) => {
        if (json.success) {
          this.setState({
            contactStatus: 'Your message has been successfully submitted.',
          });
        } else {
          this.setState({ contactStatus: json.errors[0], submitted: false });
        }
      })
      .catch((error) =>
        this.setState({
          contactStatus: JSON.stringify(error),
          submitted: false,
        }),
      );
  }

  render() {
    const { state } = this;
    const validationsPassed = every(
      pick(state, ['email', 'subject', 'name', 'message', 'captcha']),
      ({ validationState }) => validationState === SUCCESS,
    );

    return (
      <div>
        <form>
          <FieldGroup
            {...state.name}
            label="Name"
            onChange={(e) => this.handleFieldChange(e, 'name')}
          />

          <FieldGroup
            {...state.email}
            type="email"
            label="Your Email address"
            onChange={(e) => this.handleFieldChange(e, 'email')}
          />

          <FieldGroup
            {...state.subject}
            label="Subject"
            onChange={(e) => this.handleFieldChange(e, 'subject')}
          />

          <FieldGroup
            {...state.message}
            label="Message"
            componentClass="textarea"
            onChange={(e) => this.handleFieldChange(e, 'message')}
          />

          <FormGroup>
            <Visible modes={(m) => m > 0}>
              <OverlayTrigger
                placement="left"
                overlay={
                  <Tooltip id="contactFormTooltip">
                    You are in preview mode. Once you register your website, you
                    can be contacted here.
                  </Tooltip>
                }
              >
                <Button>Submit</Button>
              </OverlayTrigger>
            </Visible>

            <Visible modes={0}>
              <Captcha
                onSuccess={(value) =>
                  this.setState({ captcha: generateField(SUCCESS, value) })
                }
              />
            </Visible>
          </FormGroup>

          <Visible modes={0}>
            <FormGroup>
              <Button
                disabled={!validationsPassed || state.submitted}
                onClick={(e) => this.onSubmitClick(e)}
              >
                {' '}
                Submit{' '}
              </Button>
              <div>{this.state.contactStatus}</div>
            </FormGroup>
          </Visible>
        </form>
      </div>
    );
  }
}

export default ContactForm;
